import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { TuiLetModule } from '@taiga-ui/cdk';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [AsyncPipe, TuiLetModule],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input({ required: true }) me: boolean;
  @Input({ required: true }) firstName: Nullable<string>;
  @Input({ required: true }) lastName: Nullable<string>;

  get initials() {
    return [this.firstName?.slice(0, 1), this.lastName?.slice(0, 1)].join('');
  }
}
